/* éclore — C-vitaminguide: sticky CTA som visas efter hero, döljs medan produkturval eller slutbanner syns. */
(function () {
  'use strict';
  var st = document.querySelector('[data-vitc-gsticky]');
  if (!st) return;
  function el(id) { return id ? document.getElementById(id) : null; }
  var hero = el(st.getAttribute('data-after'));
  var hide = (st.getAttribute('data-hide') || '').split(',').map(function (s) { return el(s.trim()); }).filter(Boolean);
  function inView(n) { var r = n.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  var ticking = false;
  function update() {
    ticking = false;
    var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var blocked = hide.some(inView);
    st.classList.toggle('vitc-show', past && !blocked);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();
